import React from 'react';
import '../assets/css/bootstrap.min.css';
import '../assets/css/font-awesome.min.css';
import '../assets/css/fontawesome-stars-o.min.css';
import '../assets/css/responsive-style.css';
import '../assets/css/colors/theme-color-1.css';
import '../assets/css/custom.css';
import '../assets/css/home.css';

const Contact = () => {
  return (
    <div>
  {/* Posts Filter Bar Start */}
  <div className="posts--filter-bar style--1 hidden-xs">
    <div className="container">
      <ul className="nav">
        <li>
          <a href="#">
            <i className="fa fa-star-o" />
            <span>Featured News</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-heart-o" />
            <span>Most Popular</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-fire" />
            <span>Hot News</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-flash" />
            <span>Trending News</span>
          </a>
        </li>
        <li>
          <a href="#">
            <i className="fa fa-eye" />
            <span>Most Watched</span>
          </a>
        </li>
      </ul>
    </div>
  </div>
  {/* Posts Filter Bar End */}
  {/* News Ticker Start */}
  <div className="news--ticker">
    <div className="container">
      <div className="title">
        <h2>News Updates</h2>
        <span>(Update 12 minutes ago)</span>
      </div>
      <div className="news-updates--list" data-marquee="true">
        <ul className="nav">
          <li>
            <h3 className="h3"><a href="#">Contrary to popular belief Lorem Ipsum is not simply random text.</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Education to popular belief Lorem Ipsum is not simply</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Lorem ipsum dolor sit amet consectetur adipisicing elit.</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Corporis repellendus perspiciatis reprehenderit.</a></h3>
          </li>
          <li>
            <h3 className="h3"><a href="#">Deleniti consequatur laudantium sit aspernatur?</a></h3>
          </li>
        </ul>
      </div>
    </div>
  </div>
  {/* News Ticker End */}
  {/* Main Breadcrumb Start */}
  <div className="main--breadcrumb">
    <div className="container">
      <ul className="breadcrumb">
        <li><a href="home-1.html" className="btn-link"><i className="fa fm fa-home" />Home</a></li>
        <li className="active"><span>National</span></li>
      </ul>
    </div>
  </div>
  {/* Main Breadcrumb End */}
  {/* Main Content Section Start */}
  <div className="main-content--section pbottom--30">
    <div className="container">
      {/* Main Content Start */}
      <div className="main--content">
        {/* Post Items Start */}
        <div className="post--items post--items-1 pd--30-0">
          <div className="row gutter--15">
            <div className="col-md-3">
              <div className="row gutter--15">
                <div className="col-md-12 col-xs-6 col-xxs-12">
                  {/* Post Item Start */}
                  <div className="post--item post--layout-1 post--title-large">
                    <div className="post--img">
                      <a href="news-single-v1.html" className="thumb"><img src="img/national-img/banner-01.jpg" alt /></a>
                      <a href="#" className="cat">Animal Planet</a>
                      <a href="#" className="icon"><i className="fa fa-flash" /></a>
                      <div className="post--info">
                        <ul className="nav meta">
                          <li><a href="#">Corey I. Dean</a></li>
                          <li><a href="#">20 April 2017</a></li>
                        </ul>
                        <div className="title">
                          <h2 className="h4"><a href="news-single-v1.html" className="btn-link">Lorem Ipsum is simply dummy text of the printing</a></h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </div>
                <div className="col-md-12 col-xs-6 hidden-xxs">
                  {/* Post Item Start */}
                  <div className="post--item post--layout-1 post--title-large">
                    <div className="post--img">
                      <a href="news-single-v1.html" className="thumb"><img src="img/national-img/banner-02.jpg" alt /></a>
                      <a href="#" className="cat">Accident</a>
                      <a href="#" className="icon"><i className="fa fa-support" /></a>
                      <div className="post--info">
                        <ul className="nav meta">
                          <li><a href="#">Corey I. Dean</a></li>
                          <li><a href="#">20 April 2017</a></li>
                        </ul>
                        <div className="title">
                          <h2 className="h4"><a href="news-single-v1.html" className="btn-link">Lorem Ipsum is simply dummy text of the printing</a></h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </div>
              </div>
            </div>
            <div className="col-md-6">
              {/* Post Item Start */}
              <div className="post--item post--layout-1 post--title-larger">
                <div className="post--img">
                  <a href="news-single-v1.html" className="thumb"><img src="img/national-img/banner-03.jpg" alt /></a>
                  <a href="#" className="cat">Peace</a>
                  <a href="#" className="icon"><i className="fa fa-star-o" /></a>
                  <div className="post--info">
                    <ul className="nav meta">
                      <li><a href="#">Norma R. Hogan</a></li>
                      <li><a href="#">20 April 2017</a></li>
                    </ul>
                    <div className="title">
                      <h2 className="h4"><a href="news-single-v1.html" className="btn-link">Siriyan civil war getting righteous indignation and dislike men who are so beguiled and demoralized by the sure.</a></h2>
                    </div>
                  </div>
                </div>
              </div>
              {/* Post Item End */}
            </div>
            <div className="col-md-3">
              <div className="row gutter--15">
                <div className="col-md-12 col-xs-6 col-xxs-12">
                  {/* Post Item Start */}
                  <div className="post--item post--layout-1 post--title-large">
                    <div className="post--img">
                      <a href="news-single-v1.html" className="thumb"><img src="img/national-img/banner-04.jpg" alt /></a>
                      <a href="#" className="cat">Discover</a>
                      <a href="#" className="icon"><i className="fa fa-flash" /></a>
                      <div className="post--info">
                        <ul className="nav meta">
                          <li><a href="#">Leraje</a></li>
                          <li><a href="#">20 April 2017</a></li>
                        </ul>
                        <div className="title">
                          <h2 className="h4"><a href="news-single-v1.html" className="btn-link">Lorem Ipsum is simply dummy text of the printing</a></h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </div>
                <div className="col-md-12 col-xs-6 hidden-xxs">
                  {/* Post Item Start */}
                  <div className="post--item post--layout-1 post--title-large">
                    <div className="post--img">
                      <a href="news-single-v1.html" className="thumb"><img src="img/national-img/banner-05.jpg" alt /></a>
                      <a href="#" className="cat">Education</a>
                      <a href="#" className="icon"><i className="fa fa-book" /></a>
                      <div className="post--info">
                        <ul className="nav meta">
                          <li><a href="#">Balam</a></li>
                          <li><a href="#">20 April 2017</a></li>
                        </ul>
                        <div className="title">
                          <h2 className="h4"><a href="news-single-v1.html" className="btn-link">On the other hand, we denounce with righteous and deby</a></h2>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Post Items End */}
      </div>
      {/* Main Content End */}
      <div className="row">
        {/* Main Content Start */}
        <div className="main--content col-md-8 col-sm-7" data-sticky-content="true">
          <div className="sticky-content-inner">
            <div className="row">
              {/* Politics Start */}
              <div className="col-md-6 ptop--30 pbottom--30">
                {/* Post Items Title Start */}
                <div className="post--items-title" data-ajax="tab">
                  <h2 className="h4">Politics</h2>
                  <div className="nav">
                    <a href="#" className="prev btn-link" data-ajax-action="load_prev_politics_posts">
                      <i className="fa fa-long-arrow-left" />
                    </a>
                    <span className="divider">/</span>
                    <a href="#" className="next btn-link" data-ajax-action="load_next_politics_posts">
                      <i className="fa fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
                {/* Post Items Title End */}
                {/* Post Items Start */}
                <div className="post--items post--items-2" data-ajax-content="outer">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/politics-01.jpg" alt /></a>
                          <a href="#" className="cat">Politics</a>
                          <a href="#" className="icon"><i className="fa fa-flash" /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">On the other hand, we denounce with righteous indignation and dislike demoralized</a></h3>
                            </div>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading... </a>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/politics-02.jpg" alt /></a>
                          <a href="#" className="cat">Politics</a>
                          <a href="#" className="icon"><i className="fa fa-flash" /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">On the other hand, we denounce with righteous indignation and dislike demoralized</a></h3>
                            </div>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading... </a>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* Politics End */}
              {/* Law and Justice Start */}
              <div className="col-md-6 ptop--30 pbottom--30">
                {/* Post Items Title Start */}
                <div className="post--items-title" data-ajax="tab">
                  <h2 className="h4">Law &amp; Justice</h2>
                  <div className="nav">
                    <a href="#" className="prev btn-link" data-ajax-action="load_prev_law_justice_posts">
                      <i className="fa fa-long-arrow-left" />
                    </a>
                    <span className="divider">/</span>
                    <a href="#" className="next btn-link" data-ajax-action="load_next_law_justice_posts">
                      <i className="fa fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
                {/* Post Items Title End */}
                {/* Post Items Start */}
                <div className="post--items post--items-3" data-ajax-content="outer">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/law-justice-01.jpg" alt /></a>
                          <a href="#" className="cat">Law</a>
                          <a href="#" className="icon"><i className="fa fa-heart-o" /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Bathin</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/law-justice-02.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Bune</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/law-justice-03.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Bune</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/law-justice-04.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Bune</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/law-justice-05.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Bune</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* Law and Justice End */}
              {/* Ad Start */}
              <div className="col-md-12 ptop--30 pbottom--30">
                {/* Advertisement Start */}
                <div className="ad--space">
                  <a href="#">
                    <img src="img/ads-img/ad-728x90-02.jpg" alt className="center-block" />
                  </a>
                </div>
                {/* Advertisement End */}
              </div>
              {/* Ad End */}
              {/* Accident and Inaccident Start */}
              <div className="col-md-12 ptop--30 pbottom--30">
                {/* Post Items Title Start */}
                <div className="post--items-title" data-ajax="tab">
                  <h2 className="h4">Accident &amp; Inaccident</h2>
                  <div className="nav">
                    <a href="#" className="prev btn-link" data-ajax-action="load_prev_accident_inaccident_posts">
                      <i className="fa fa-long-arrow-left" />
                    </a>
                    <span className="divider">/</span>
                    <a href="#" className="next btn-link" data-ajax-action="load_next_accident_inaccident_posts">
                      <i className="fa fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
                {/* Post Items Title End */}
                {/* Post Items Start */}
                <div className="post--items post--items-2" data-ajax-content="outer">
                  <ul className="nav row" data-ajax-content="inner">
                    <li className="col-md-12">
                      {/* Post Item Start */}
                      <div className="post--item">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="post--img">
                              <a href="news-single-v1.html" className="thumb"><img src="img/national-img/accident-inaccident-01.jpg" alt /></a>
                              <a href="#" className="cat">Airlines</a>
                              <a href="#" className="icon"><i className="fa fa-star-o" /></a>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="post--info">
                              <ul className="nav meta">
                                <li><a href="#">Vassago</a></li>
                                <li><a href="#">Today 03:30 am</a></li>
                              </ul>
                              <div className="title">
                                <h3 className="h4"><a href="news-single-v1.html" className="btn-link">At vero eos et accusamus et iusto odio dignissimos uniti atque corrupti quos dolores et quas.</a></h3>
                              </div>
                            </div>
                            <div className="post--content">
                              <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                            </div>
                            <div className="post--action">
                              <a href="news-single-v1.html">Continue Reading...</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li className="col-md-12">
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li className="col-md-6">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/accident-inaccident-02.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Demiurge</a></li>
                              <li><a href="#">Today 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li className="col-md-12 hidden-md hidden-lg">
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li className="col-md-6">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/accident-inaccident-03.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Demiurge</a></li>
                              <li><a href="#">Today 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li className="col-md-12">
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li className="col-md-6">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/accident-inaccident-04.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Demiurge</a></li>
                              <li><a href="#">Today 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li className="col-md-12 hidden-md hidden-lg">
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li className="col-md-6">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-4">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/accident-inaccident-05.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Demiurge</a></li>
                              <li><a href="#">Today 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* Accident and Inaccident End */}
              {/* Diplomacy Start */}
              <div className="col-md-6 ptop--30 pbottom--30">
                {/* Post Items Title Start */}
                <div className="post--items-title" data-ajax="tab">
                  <h2 className="h4">Diplomacy</h2>
                  <div className="nav">
                    <a href="#" className="prev btn-link" data-ajax-action="load_prev_diplomacy_posts">
                      <i className="fa fa-long-arrow-left" />
                    </a>
                    <span className="divider">/</span>
                    <a href="#" className="next btn-link" data-ajax-action="load_next_diplomacy_posts">
                      <i className="fa fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
                {/* Post Items Title End */}
                {/* Post Items Start */}
                <div className="post--items post--items-2" data-ajax-content="outer">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/diplomacy-01.jpg" alt /></a>
                          <a href="#" className="cat">Diplomatic</a>
                          <a href="#" className="icon"><i className="fa fa-flash" /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="#" className="btn-link">On the other hand, we denounce with righteous indignation and dislike demoralized</a></h3>
                            </div>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading... </a>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/diplomacy-02.jpg" alt /></a>
                          <a href="#" className="cat">Talk-Show</a>
                          <a href="#" className="icon"><i className="fa fa-flash" /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">On the other hand, we denounce with righteous indignation and dislike demoralized</a></h3>
                            </div>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading... </a>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* Diplomacy End */}
              {/* Administration Start */}
              <div className="col-md-6 ptop--30 pbottom--30">
                {/* Post Items Title Start */}
                <div className="post--items-title" data-ajax="tab">
                  <h2 className="h4">Administration</h2>
                  <div className="nav">
                    <a href="#" className="prev btn-link" data-ajax-action="load_prev_administration_posts">
                      <i className="fa fa-long-arrow-left" />
                    </a>
                    <span className="divider">/</span>
                    <a href="#" className="next btn-link" data-ajax-action="load_next_administration_posts">
                      <i className="fa fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
                {/* Post Items Title End */}
                {/* Post Items Start */}
                <div className="post--items post--items-2" data-ajax-content="outer">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/administration-01.jpg" alt /></a>
                          <a href="#" className="cat">Command</a>
                          <a href="#" className="icon"><i className="fa fa-flash" /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">On the other hand, we denounce with righteous indignation and dislike demoralized</a></h3>
                            </div>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading... </a>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/administration-02.jpg" alt /></a>
                          <a href="#" className="cat">Regulation</a>
                          <a href="#" className="icon"><i className="fa fa-flash" /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Famous</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">On the other hand, we denounce with righteous indignation and dislike demoralized</a></h3>
                            </div>
                          </div>
                        </div>
                        <div className="post--content">
                          <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                        </div>
                        <div className="post--action">
                          <a href="news-single-v1.html">Continue Reading... </a>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* Administration End */}
            </div>
          </div>
        </div>
        {/* Main Content End */}
        {/* Main Sidebar Start */}
        <div className="main--sidebar col-md-4 col-sm-5 ptop--30 pbottom--30" data-sticky-content="true">
          <div className="sticky-content-inner">
            {/* Widget Start */}
            <div className="widget">
              {/* Ad Widget Start */}
              <div className="ad--widget">
                <a href="#">
                  <img src="img/ads-img/ad-300x250-1.jpg" alt />
                </a>
              </div>
              {/* Ad Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Stay Connected</h2>
                <i className="icon fa fa-share-alt" />
              </div>
              {/* Social Widget Start */}
              <div className="social--widget style--1">
                <ul className="nav">
                  <li className="facebook">
                    <a href="#">
                      <span className="icon"><i className="fa fa-facebook-f" /></span>
                      <span className="count">521</span>
                      <span className="title">Likes</span>
                    </a>
                  </li>
                  <li className="twitter">
                    <a href="#">
                      <span className="icon"><i className="fa fa-twitter" /></span>
                      <span className="count">3297</span>
                      <span className="title">Followers</span>
                    </a>
                  </li>
                  <li className="google-plus">
                    <a href="#">
                      <span className="icon"><i className="fa fa-google-plus" /></span>
                      <span className="count">596282</span>
                      <span className="title">Followers</span>
                    </a>
                  </li>
                  <li className="rss">
                    <a href="#">
                      <span className="icon"><i className="fa fa-rss" /></span>
                      <span className="count">521</span>
                      <span className="title">Subscriber</span>
                    </a>
                  </li>
                  <li className="vimeo">
                    <a href="#">
                      <span className="icon"><i className="fa fa-vimeo" /></span>
                      <span className="count">3297</span>
                      <span className="title">Followers</span>
                    </a>
                  </li>
                  <li className="youtube">
                    <a href="#">
                      <span className="icon"><i className="fa fa-youtube-square" /></span>
                      <span className="count">596282</span>
                      <span className="title">Subscriber</span>
                    </a>
                  </li>
                </ul>
              </div>
              {/* Social Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Get Newsletter</h2>
                <i className="icon fa fa-envelope-open-o" />
              </div>
              {/* Subscribe Widget Start */}
              <div className="subscribe--widget">
                <div className="content">
                  <p>Subscribe to our newsletter to get  latest news, popular news and exclusive updates.</p>
                </div>
                <form action="https://themelooks.us13.list-manage.com/subscribe/post?u=79f0b132ec25ee223bb41835f&id=f4e0e93d1d" method="post" name="mc-embedded-subscribe-form" target="_blank" data-form="mailchimpAjax">
                  <div className="input-group">
                    <input type="email" name="EMAIL" placeholder="E-mail address" className="form-control" autoComplete="off" required />
                    <div className="input-group-btn">
                      <button type="submit" className="btn btn-lg btn-default active"><i className="fa fa-paper-plane-o" /></button>
                    </div>
                  </div>
                  <div className="status" />
                </form>
              </div>
              {/* Subscribe Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Featured News</h2>
                <i className="icon fa fa-newspaper-o" />
              </div>
            
              <div className="list--widget list--widget-1">
                {/* Post Items Start */}
                <div className="post--items post--items-3" data-ajax-content="outer">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/news-widget-01.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Ninurta</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/news-widget-02.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Orcus</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/news-widget-03.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Rahab</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/news-widget-04.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Tannin</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* List Widgets End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title">
                <h2 className="h4">Advertisement</h2>
                <i className="icon fa fa-bullhorn" />
              </div>
              {/* Ad Widget Start */}
              <div className="ad--widget">
                <a href="#">
                  <img src="img/ads-img/ad-300x250-2.jpg" alt />
                </a>
              </div>
              {/* Ad Widget End */}
            </div>
            {/* Widget End */}
          </div>
        </div>
        {/* Main Sidebar End */}
      </div>
      {/* Main Content Start */}
      <div className="main--content pd--30-0">
        {/* Post Items Title Start */}
        <div className="post--items-title" data-ajax="tab">
          <h2 className="h4">Audio &amp; Videos</h2>
          <div className="nav">
            <a href="#" className="prev btn-link" data-ajax-action="load_prev_audio_video_posts">
              <i className="fa fa-long-arrow-left" />
            </a>
            <span className="divider">/</span>
            <a href="#" className="next btn-link" data-ajax-action="load_next_audio_video_posts">
              <i className="fa fa-long-arrow-right" />
            </a>
          </div>
        </div>
        {/* Post Items Title End */}
        {/* Post Items Start */}
        <div className="post--items post--items-4" data-ajax-content="outer">
          <ul className="nav row" data-ajax-content="inner">
            <li className="col-md-8">
              {/* Post Item Start */}
              <div className="post--item post--layout-1 post--type-video post--title-large">
                <div className="post--img">
                  <a href="news-single-v1.html" className="thumb"><img src="img/national-img/audio-video-01.jpg" alt /></a>
                  <a href="#" className="cat">Beach</a>
                  <a href="#" className="icon"><i className="fa fa-eye" /></a>
                  <div className="post--info">
                    <ul className="nav meta">
                      <li><a href="#">Succubus</a></li>
                      <li><a href="#">Today 03:52 pm</a></li>
                    </ul>
                    <div className="title">
                      <h2 className="h4"><a href="news-single-v1.html" className="btn-link">Standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum</a></h2>
                    </div>
                  </div>
                </div>
              </div>
              {/* Post Item End */}
              {/* Divider Start */}
              <hr className="divider hidden-md hidden-lg" />
              {/* Divider End */}
            </li>
            <li className="col-md-4">
              <ul className="nav">
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--type-audio post--layout-3">
                    <div className="post--img">
                      <a href="news-single-v1.html" className="thumb"><img src="img/national-img/audio-video-02.jpg" alt /></a>
                      <div className="post--info">
                        <ul className="nav meta">
                          <li><a href="#">Maclaan John</a></li>
                          <li><a href="#">16 April 2017</a></li>
                        </ul>
                        <div className="title">
                          <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--type-video post--layout-3">
                    <div className="post--img">
                      <a href="news-single-v1.html" className="thumb"><img src="img/national-img/audio-video-03.jpg" alt /></a>
                      <div className="post--info">
                        <ul className="nav meta">
                          <li><a href="#">Maclaan John</a></li>
                          <li><a href="#">16 April 2017</a></li>
                        </ul>
                        <div className="title">
                          <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--type-audio post--layout-3">
                    <div className="post--img">
                      <a href="news-single-v1.html" className="thumb"><img src="img/national-img/audio-video-04.jpg" alt /></a>
                      <div className="post--info">
                        <ul className="nav meta">
                          <li><a href="#">Maclaan John</a></li>
                          <li><a href="#">16 April 2017</a></li>
                        </ul>
                        <div className="title">
                          <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
                <li>
                  {/* Post Item Start */}
                  <div className="post--item post--type-video post--layout-3">
                    <div className="post--img">
                      <a href="news-single-v1.html" className="thumb"><img src="img/national-img/audio-video-05.jpg" alt /></a>
                      <div className="post--info">
                        <ul className="nav meta">
                          <li><a href="#">Maclaan John</a></li>
                          <li><a href="#">16 April 2017</a></li>
                        </ul>
                        <div className="title">
                          <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted by the readable</a></h3>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Post Item End */}
                </li>
              </ul>
            </li>
          </ul>
          {/* Preloader Start */}
          <div className="preloader bg--color-0--b" data-preloader={1}>
            <div className="preloader--inner" />
          </div>
          {/* Preloader End */}
        </div>
        {/* Post Items End */}
      </div>
      {/* Main Content End */}
      {/* Advertisement Start */}
      <div className="ad--space pd--30-0">
        <a href="#">
          <img src="img/ads-img/ad-970x90.jpg" alt className="center-block" />
        </a>
      </div>
      {/* Advertisement End */}
      <div className="row">
        {/* Main Content Start */}
        <div className="main--content col-md-8 col-sm-7" data-sticky-content="true">
          <div className="sticky-content-inner">
            <div className="row">
              {/* Crime Start */}
              <div className="col-md-12 ptop--30 pbottom--30">
                {/* Post Items Title Start */}
                <div className="post--items-title" data-ajax="tab">
                  <h2 className="h4">Crime</h2>
                  <div className="nav">
                    <a href="#" className="prev btn-link" data-ajax-action="load_prev_crime_posts">
                      <i className="fa fa-long-arrow-left" />
                    </a>
                    <span className="divider">/</span>
                    <a href="#" className="next btn-link" data-ajax-action="load_next_crime_posts">
                      <i className="fa fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
                {/* Post Items Title End */}
                {/* Post Items Start */}
                <div className="post--items" data-ajax-content="outer">
                  <ul className="nav row gutter--15" data-ajax-content="inner">
                    <li className="col-md-4 col-xs-6 col-xxs-12">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/crime-01.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li className="col-xs-12 hidden shown-xxs">
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li className="col-md-4 col-xs-6 col-xxs-12">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/crime-02.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li className="col-md-4 hidden-sm hidden-xs">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/crime-03.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Yeasterday 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* Crime End */}
              {/* Election Start */}
              <div className="col-md-12 ptop--30 pbottom--30">
                {/* Post Items Title Start */}
                <div className="post--items-title" data-ajax="tab">
                  <h2 className="h4">Election</h2>
                  <div className="nav">
                    <a href="#" className="prev btn-link" data-ajax-action="load_prev_election_posts">
                      <i className="fa fa-long-arrow-left" />
                    </a>
                    <span className="divider">/</span>
                    <a href="#" className="next btn-link" data-ajax-action="load_next_election_posts">
                      <i className="fa fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
                {/* Post Items Title End */}
                {/* Post Items Start */}
                <div className="post--items post--items-2" data-ajax-content="outer">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="post--img">
                              <a href="news-single-v1.html" className="thumb"><img src="img/national-img/election-01.jpg" alt /></a>
                              <a href="#" className="cat">News</a>
                              <a href="#" className="icon"><i className="fa fa-star-o" /></a>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="post--info">
                              <ul className="nav meta">
                                <li><a href="#">Vassago</a></li>
                                <li><a href="#">Today 03:30 am</a></li>
                              </ul>
                              <div className="title">
                                <h3 className="h4"><a href="#" className="btn-link">At vero eos et accusamus et iusto odio dignissimos uniti atque corrupti quos dolores et quas.</a></h3>
                              </div>
                            </div>
                            <div className="post--content">
                              <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                            </div>
                            <div className="post--action">
                              <a href="news-single-v1.html">Continue Reading...</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="post--img">
                              <a href="news-single-v1.html" className="thumb"><img src="img/national-img/election-02.jpg" alt /></a>
                              <a href="#" className="cat">News</a>
                              <a href="#" className="icon"><i className="fa fa-flash" /></a>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="post--info">
                              <ul className="nav meta">
                                <li><a href="#">Vassago</a></li>
                                <li><a href="#">Today 03:30 am</a></li>
                              </ul>
                              <div className="title">
                                <h3 className="h4"><a href="news-single-v1.html" className="btn-link">At vero eos et accusamus et iusto odio dignissimos uniti atque corrupti quos dolores et quas.</a></h3>
                              </div>
                            </div>
                            <div className="post--content">
                              <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                            </div>
                            <div className="post--action">
                              <a href="news-single-v1.html">Continue Reading...</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Divider Start */}
                      <hr className="divider" />
                      {/* Divider End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item">
                        <div className="row">
                          <div className="col-md-6">
                            <div className="post--img">
                              <a href="news-single-v1.html" className="thumb"><img src="img/national-img/election-03.jpg" alt /></a>
                              <a href="#" className="cat">News</a>
                              <a href="#" className="icon"><i className="fa fa-heart-o" /></a>
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="post--info">
                              <ul className="nav meta">
                                <li><a href="#">Vassago</a></li>
                                <li><a href="#">Today 03:30 am</a></li>
                              </ul>
                              <div className="title">
                                <h3 className="h4"><a href="news-single-v1.html" className="btn-link">At vero eos et accusamus et iusto odio dignissimos uniti atque corrupti quos dolores et quas.</a></h3>
                              </div>
                            </div>
                            <div className="post--content">
                              <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos mollitia animi, id est laborum et dolorum fuga.</p>
                            </div>
                            <div className="post--action">
                              <a href="news-single-v1.html">Continue Reading...</a>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* Election End */}
              {/* Photo Gallery Start */}
              <div className="col-md-12 ptop--30 pbottom--30">
                {/* Post Items Title Start */}
                <div className="post--items-title" data-ajax="tab">
                  <h2 className="h4">Photo Gallery</h2>
                  <div className="nav">
                    <a href="#" className="prev btn-link" data-ajax-action="load_prev_photo_gallery_posts">
                      <i className="fa fa-long-arrow-left" />
                    </a>
                    <span className="divider">/</span>
                    <a href="#" className="next btn-link" data-ajax-action="load_next_photo_gallery_posts">
                      <i className="fa fa-long-arrow-right" />
                    </a>
                  </div>
                </div>
                {/* Post Items Title End */}
                {/* Post Items Start */}
                <div className="post--items post--items-1" data-ajax-content="outer">
                  <ul className="nav row gutter--15" data-ajax-content="inner">
                    <li className="col-md-12">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1 post--title-large">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/photo-gallery-01.jpg" alt /></a>
                          <a href="#" className="cat">Poor</a>
                          <a href="#" className="icon"><i className="fa fa-eye" /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Today 05:52 pm</a></li>
                            </ul>
                            <div className="title text-xxs-ellipsis">
                              <h2 className="h4"><a href="news-single-v1.html" className="btn-link">Standard chunk of Lorem Ipsum used since the 1500s is reproduced below for those interested. Sections 1.10.32 and 1.10.33 from "de Finibus Bonorum</a></h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li className="col-md-4 col-xs-6 col-xxs-12">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/photo-gallery-02.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Today 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h2 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li className="col-md-4 col-xs-6 col-xxs-12">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/photo-gallery-03.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Today 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h2 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li className="col-md-4 hidden-sm hidden-xs">
                      {/* Post Item Start */}
                      <div className="post--item post--layout-1">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/national-img/photo-gallery-04.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Astaroth</a></li>
                              <li><a href="#">Today 03:52 pm</a></li>
                            </ul>
                            <div className="title">
                              <h2 className="h4"><a href="news-single-v1.html" className="btn-link">It is a long established fact that a reader will be distracted by</a></h2>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* Photo Gallery End */}
              {/* Pagination Start */}
              <div className="col-md-12">
                <div className="pagination--wrapper ptop--30 pbottom--30 clearfix">
                  <p className="pagination-hint float--left">Page 02 of 03</p>
                  <ul className="pagination float--right">
                    <li><a href="#"><i className="fa fa-long-arrow-left" /></a></li>
                    <li><a href="#">01</a></li>
                    <li className="active"><span>02</span></li>
                    <li><a href="#">03</a></li>
                    <li><a href="#"><i className="fa fa-long-arrow-right" /></a></li>
                  </ul>
                </div>
              </div>
              {/* Pagination End */}
            </div>
          </div>
        </div>
        {/* Main Content End */}
        {/* Main Sidebar Start */}
        <div className="main--sidebar col-md-4 col-sm-5 ptop--30 pbottom--30" data-sticky-content="true">
          <div className="sticky-content-inner">
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title" data-ajax="tab">
                <h2 className="h4">Voting Poll (Checkbox)</h2>
                <div className="nav">
                  <a href="#" className="prev btn-link" data-ajax-action="load_prev_poll_widget">
                    <i className="fa fa-long-arrow-left" />
                  </a>
                  <span className="divider">/</span>
                  <a href="#" className="next btn-link" data-ajax-action="load_next_poll_widget">
                    <i className="fa fa-long-arrow-right" />
                  </a>
                </div>
              </div>
              {/* Poll Widget Start */}
              <div className="poll--widget" data-ajax-content="outer">
                <ul className="nav" data-ajax-content="inner">
                  <li className="title">
                    <h3 className="h4">Which was the best Football World Cup ever in your opinion?</h3>
                  </li>
                  <li className="options">
                    <form action="#">
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="option-1" />
                          <span>Brazil 2014</span>
                        </label>
                        <p>65%<span style={{width: '65%'}} /></p>
                      </div>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="option-2" />
                          <span>South Africa 2010</span>
                        </label>
                        <p>28%<span style={{width: '28%'}} /></p>
                      </div>
                      <div className="checkbox">
                        <label>
                          <input type="checkbox" name="option-2" />
                          <span>Germany 2006</span>
                        </label>
                        <p>07%<span style={{width: '07%'}} /></p>
                      </div>
                      <button type="submit" className="btn btn-primary">Vote Now</button>
                    </form>
                  </li>
                </ul>
                {/* Preloader Start */}
                <div className="preloader bg--color-0--b" data-preloader={1}>
                  <div className="preloader--inner" />
                </div>
                {/* Preloader End */}
              </div>
              {/* Poll Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title" data-ajax="tab">
                <h2 className="h4">Voting Poll (Radio)</h2>
                <div className="nav">
                  <a href="#" className="prev btn-link" data-ajax-action="load_prev_poll_widget">
                    <i className="fa fa-long-arrow-left" />
                  </a>
                  <span className="divider">/</span>
                  <a href="#" className="next btn-link" data-ajax-action="load_next_poll_widget">
                    <i className="fa fa-long-arrow-right" />
                  </a>
                </div>
              </div>
              {/* Poll Widget Start */}
              <div className="poll--widget" data-ajax-content="outer">
                <ul className="nav" data-ajax-content="inner">
                  <li className="title">
                    <h3 className="h4">Do you think the cost of sending money to mobile phone should be reduced?</h3>
                  </li>
                  <li className="options">
                    <form action="#">
                      <div className="radio">
                        <label>
                          <input type="radio" name="option-1" />
                          <span>Yes</span>
                        </label>
                        <p>65%<span style={{width: '65%'}} /></p>
                      </div>
                      <div className="radio">
                        <label>
                          <input type="radio" name="option-1" />
                          <span>No</span>
                        </label>
                        <p>28%<span style={{width: '28%'}} /></p>
                      </div>
                      <div className="radio">
                        <label>
                          <input type="radio" name="option-1" />
                          <span>Average</span>
                        </label>
                        <p>07%<span style={{width: '07%'}} /></p>
                      </div>
                      <button type="submit" className="btn btn-primary">Vote Now</button>
                    </form>
                  </li>
                </ul>
                {/* Preloader Start */}
                <div className="preloader bg--color-0--b" data-preloader={1}>
                  <div className="preloader--inner" />
                </div>
                {/* Preloader End */}
              </div>
              {/* Poll Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              {/* Ad Widget Start */}
              <div className="ad--widget">
                <div className="row">
                  <div className="col-sm-6">
                    <a href="#">
                      <img src="img/ads-img/ad-150x150-1.jpg" alt />
                    </a>
                  </div>
                  <div className="col-sm-6">
                    <a href="#">
                      <img src="img/ads-img/ad-150x150-2.jpg" alt />
                    </a>
                  </div>
                </div>
              </div>
              {/* Ad Widget End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title" data-ajax="tab">
                <h2 className="h4">Readers Opinion</h2>
                <div className="nav">
                  <a href="#" className="prev btn-link" data-ajax-action="load_prev_readers_opinion_widget">
                    <i className="fa fa-long-arrow-left" />
                  </a>
                  <span className="divider">/</span>
                  <a href="#" className="next btn-link" data-ajax-action="load_next_readers_opinion_widget">
                    <i className="fa fa-long-arrow-right" />
                  </a>
                </div>
              </div>
              {/* List Widgets Start */}
              <div className="list--widget list--widget-2" data-ajax-content="outer">
                {/* Post Items Start */}
                <div className="post--items post--items-3">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <span className="thumb">
                            <img src="img/widgets-img/readers-opinion-01.png" alt />
                          </span>
                          <div className="post--info">
                            <div className="title">
                              <h3 className="h4">Long established fact that a reader will be distracted</h3>
                            </div>
                            <ul className="nav meta">
                              <li><span>by Ninurta</span></li>
                              <li><span>16 April 2017</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <span className="thumb">
                            <img src="img/widgets-img/readers-opinion-02.png" alt />
                          </span>
                          <div className="post--info">
                            <div className="title">
                              <h3 className="h4">Long established fact that a reader will be distracted</h3>
                            </div>
                            <ul className="nav meta">
                              <li><span>by Ninurta</span></li>
                              <li><span>16 April 2017</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <span className="thumb">
                            <img src="img/widgets-img/readers-opinion-03.png" alt />
                          </span>
                          <div className="post--info">
                            <div className="title">
                              <h3 className="h4">Long established fact that a reader will be distracted</h3>
                            </div>
                            <ul className="nav meta">
                              <li><span>by Ninurta</span></li>
                              <li><span>16 April 2017</span></li>
                            </ul>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* List Widgets End */}
            </div>
            {/* Widget End */}
            {/* Widget Start */}
            <div className="widget">
              <div className="widget--title" data-ajax="tab">
                <h2 className="h4">Editors Choice</h2>
                <div className="nav">
                  <a href="#" className="prev btn-link" data-ajax-action="load_prev_editors_choice_widget">
                    <i className="fa fa-long-arrow-left" />
                  </a>
                  <span className="divider">/</span>
                  <a href="#" className="next btn-link" data-ajax-action="load_next_editors_choice_widget">
                    <i className="fa fa-long-arrow-right" />
                  </a>
                </div>
              </div>
              {/* List Widgets Start */}
              <div className="list--widget list--widget-1" data-ajax-content="outer">
                {/* Post Items Start */}
                <div className="post--items post--items-3">
                  <ul className="nav" data-ajax-content="inner">
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/editors-choice-01.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Ninurta</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/editors-choice-02.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Orcus</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/editors-choice-03.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Rahab</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                    <li>
                      {/* Post Item Start */}
                      <div className="post--item post--layout-3">
                        <div className="post--img">
                          <a href="news-single-v1.html" className="thumb"><img src="img/widgets-img/editors-choice-04.jpg" alt /></a>
                          <div className="post--info">
                            <ul className="nav meta">
                              <li><a href="#">Tannin</a></li>
                              <li><a href="#">16 April 2017</a></li>
                            </ul>
                            <div className="title">
                              <h3 className="h4"><a href="news-single-v1.html" className="btn-link">Long established fact that a reader will be distracted</a></h3>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* Post Item End */}
                    </li>
                  </ul>
                  {/* Preloader Start */}
                  <div className="preloader bg--color-0--b" data-preloader={1}>
                    <div className="preloader--inner" />
                  </div>
                  {/* Preloader End */}
                </div>
                {/* Post Items End */}
              </div>
              {/* List Widgets End */}
            </div>
            {/* Widget End */}
          </div>
        </div>
        {/* Main Sidebar End */}
      </div>
    </div>
  </div>
  {/* Main Content Section End */}
  <div id="backToTop">
                    <a href="#"><i className="fa fa-angle-double-up"></i></a>
                </div>
</div>
  );
};

export default Contact;